import {DvirInspectionQuestionDataType} from './QuestionDatatype';
import {DvirQuestionValueProviderDto} from './dto/DvirQuestionValueProviderDto';
import {DvirQuestionAnswerMapperDto} from './dto/DvirQuestionAnswerMapperDto';
import {DvirItem} from './dvir-item';

export class DvirQuestion extends DvirItem {
  id?: number;
  title?: string;
  type: DvirInspectionQuestionDataType;

  notApplicable?: boolean;
  valueProvider?: DvirQuestionValueProviderDto;
  answerMapper?: DvirQuestionAnswerMapperDto;

  constructor(id?: number,
              title?: string,
              type: DvirInspectionQuestionDataType = DvirInspectionQuestionDataType.TEXT,
              notApplicable: boolean = undefined,
              valueProvider: DvirQuestionValueProviderDto = undefined,
              answerMapper: DvirQuestionAnswerMapperDto = undefined) {
    super();
    this.id = id;
    this.title = title;
    this.type = type;
    this.notApplicable = notApplicable;
    this.valueProvider = valueProvider;
    this.answerMapper = answerMapper;
  }
}
